export default __webpack_public_path__ + "static/media/age.b8fca8bf.png";